import { push } from 'connected-react-router';
import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';
import { openSnackbar } from 'helpers/Notifier';
import { saveAs } from 'file-saver';
import { getSessionByKey, getEncodedQueryParams } from 'helpers';

export const PRT_ACTIONS = {
  GET_PROTOCOLS: '@protocol/getprotocols',
  SET_PROTOCOL: '@protocol/setprotocol',
  SET_PROTOCOL_TAB: '@protocol/setprotocolTab'
};

export const setProtocolTab = props => dispatch => {
  const action = {
    type: PRT_ACTIONS.SET_PROTOCOL_TAB,
    payload: props
  };
  dispatch(action);
};

export const setProtocol = ({ id, tab }) => dispatch => {
  const action = {
    type: PRT_ACTIONS.SET_PROTOCOL,
    payload: id
  };
  dispatch(action);
  dispatch(setProtocolTab(tab));
  dispatch(push(getEncodedQueryParams('/protocol/', `${id}${tab}`)));
};


export const setProtocolSync = (token, loggerInfo, number) => dispatch => http
  .putWithToken(
    `protocol-data-service/${getSessionByKey('prt_url_ver')
    }/protocols/number/${number}/sync`,
    token,
    loggerInfo
  )
  .pipe(
    map(resp => resp)
  );

export const getDocContent = (token, loggerInfo, id) => dispatch => http
  .getStreamWithToken(
    `protocol-data-service/${getSessionByKey('prt_url_ver')
    }/documents/id/${id}`,
    token,
    loggerInfo
  )
  .subscribe(
    resp => {
      let filename = '';
      const disposition = resp.xhr.getResponseHeader('Content-Disposition');
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      saveAs(resp.response, filename);
    },
    err => {
      openSnackbar({
        message: getSessionByKey('edoc_not_found'),
        variant: 'error',
        name: 'doc_error'
      });
    }
  );
